var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBidsWatchRight(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 78,
    height: 96,
    viewBox: "0 0 78 96",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.2
  }, /*#__PURE__*/React.createElement("path", {
    d: "M48 88C70.0914 88 88 70.0914 88 48C88 25.9086 70.0914 8 48 8C25.9086 8 8 25.9086 8 48C8 70.0914 25.9086 88 48 88Z",
    fill: "url(#paint0_linear_3254_8414)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.15,
    d: "M48 85C68.4345 85 85 68.4345 85 48C85 27.5655 68.4345 11 48 11C27.5655 11 11 27.5655 11 48C11 68.4345 27.5655 85 48 85Z",
    fill: "url(#paint1_radial_3254_8414)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48 82C66.7777 82 82 66.7777 82 48C82 29.2223 66.7777 14 48 14C29.2223 14 14 29.2223 14 48C14 66.7777 29.2223 82 48 82Z",
    fill: "url(#paint2_radial_3254_8414)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48 48V14C38.612 14 30.112 17.806 23.958 23.958L48 48Z",
    fill: "#6EEBFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.064 14.246L48 22L51.936 14.246C50.642 14.096 49.334 14 48 14C46.666 14 45.358 14.096 44.064 14.246Z",
    fill: "url(#paint3_linear_3254_8414)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50.8259 50.832C49.2619 52.3919 46.7299 52.3899 45.1699 50.8259C43.6099 49.2619 26.0259 25.976 26.0259 25.976C26.0259 25.976 49.2739 43.6119 50.8339 45.1759C52.3939 46.7399 52.3879 49.272 50.8259 50.832Z",
    fill: "url(#paint4_linear_3254_8414)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_3254_8414",
    x1: 19.716,
    y1: 19.716,
    x2: 76.284,
    y2: 76.284,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#889097"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#64717C"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint1_radial_3254_8414",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(48 48) scale(37)"
  }, /*#__PURE__*/React.createElement("stop", null), /*#__PURE__*/React.createElement("stop", {
    offset: 0.978,
    stopOpacity: 0.022
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint2_radial_3254_8414",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(47.78 14.788) scale(75.766)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FAFAFB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C8CDD1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_3254_8414",
    x1: 44.064,
    y1: 18,
    x2: 51.936,
    y2: 18,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1D59B3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#195BBC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_3254_8414",
    x1: 39.0248,
    y1: 25.9902,
    x2: 38.9953,
    y2: 51.9891,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#889097"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#444D54"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBidsWatchRight);
export default __webpack_public_path__ + "static/media/bids-watch-right.6244c67b802fa6640a1d488601c212b5.svg";
export { ForwardRef as ReactComponent };